import React from 'react';
import uniqueId from 'lodash/uniqueId';
import getPasswordStrength from '../../../utils/passwordStrength';
import { TextParagraph } from '../Typography/TextBody.js';

import './PasswordStrength.less';

/**
 *
 * @param {{ id?:string; value?:string; className?:string; }} props
 * @returns {React.ReactElement}
 */
export const PasswordStrength = props => {
  const { id = uniqueId('password_strength_'), className, value } = props;

  const passwordStrength = getPasswordStrength(value);

  const getRequiremenrs = () => {
    return ([
      {
        description: 'Minimum of 8 characters',
        verified: passwordStrength.completionList.min8chars,
      },
      {
        description: '1 lowercase letter',
        verified: passwordStrength.completionList.lower,
      },
      {
        description: '1 uppercase letter',
        verified: passwordStrength.completionList.upper,
      },
      {
        description: '1 number',
        verified: passwordStrength.completionList.digit,
      },
      {
        description: '1 special character',
        verified: passwordStrength.completionList.special,
      },
    ]
    );
  };

  const isPasswordValid = () => passwordStrength.ruleGroups.good.complete;

  return (
    <div className={["password-validator-container", className].filter(Boolean).join(' ')} id={id}>
      <TextParagraph className='mb-2'>{isPasswordValid() ? 'Your password meets the requirements:' : 'Your password must meet these minimal requirements:'}</TextParagraph>
      <ul aria-hidden={isPasswordValid()}>
        {getRequiremenrs().map(requirement => (
          <li
            key={requirement.description}
            className={
              requirement.verified
                ? 'valid'
                : 'invalid'
            }
            aria-label={`${requirement.description} - ${requirement.verified ? 'valid' : 'required'}.`}
            title={`${requirement.description} is ${requirement.verified ? 'valid' : 'required'}.`}
          >
            {requirement.description}
            {requirement.verified ? (
              <i className="fa fa-check-circle"></i>
            ) : (
              <i className="fa fa-circle"></i>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PasswordStrength;
